export function initScrollToTopButton(options: {
    buttonId?: string;
    scrollTriggerY?: number;
} = {}) {
    const {
        buttonId = 'scroll-button-container',
        scrollTriggerY = 200
    } = options;

    const scrollBtnContainer = document.getElementById(buttonId)!;

    if (!scrollBtnContainer) return;
    function animateToTop(e: Event) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function handleScroll() {

        if (window.scrollY > scrollTriggerY) {
            scrollBtnContainer.classList.add('show');
        } else {
            scrollBtnContainer.classList.remove('show');
        }
    }

    window.addEventListener('scroll', handleScroll);
    scrollBtnContainer.addEventListener('click', animateToTop);
}